var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-list-item',{class:[
      'subheading',
      'font-weight-bold',
      'my-3'
    ]},[_c('span',{class:['icon-click', {clickable: _vm.clickable}],on:{"click":_vm.clickImage}},[_c('img',{staticClass:"icon mr-2",attrs:{"src":_vm.icon}})]),_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }